import { render, staticRenderFns } from "./DetailSideBar.vue?vue&type=template&id=1893ad8e&"
import script from "./DetailSideBar.vue?vue&type=script&lang=ts&"
export * from "./DetailSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports